import { useAuthStore } from "@/pinia/useAuthStore";
import { useFavicon } from "@vueuse/core";
import { themes } from "./index";

const THEME_CLASSES = ["connect3", "janet", "connect3-dark", "janet-dark"];

export default function useTheme() {
  const { setLogoURL } = useAuthStore();

  const applyCSSVariables = (themeName: string) => {
    const theme = themes[themeName];
    if (!theme) return false;

    const root = document.documentElement;
    Object.entries(theme).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });
    return true;
  };

  const setTheme = (themeName: string = "connect3") => {
    const html = document.documentElement;

    // Remove previous theme classes
    THEME_CLASSES.forEach((cls) => html.classList.remove(cls));
    html.classList.add(themeName);

    const success = applyCSSVariables(themeName);

    if (!success) {
      html.classList.remove(themeName);
      html.classList.add("connect3");
      applyCSSVariables("connect3");
      setLogoURL("/connect3.png");
      useFavicon("/connect3-logo.png");
    } else {
      setLogoURL(`/${themeName}.png`);
      useFavicon(`/${themeName}-logo.png`);
    }
  };

  return {
    setTheme,
  };
}
